@keyframes fade-out {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    display: none;
    opacity: 0;
  }
}

.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  &:first-child {
    padding-bottom: 1.6rem;
    border-bottom: 1px solid var(--color-stroke-default);
  }
}

.download-settings {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  justify-content: space-between;
}

.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;

  /* Was `& > ${Error}`, a reference to the styled component imported from
     components/inputs/styled-input. CSS Modules cannot target another module's
     class, so this file hands Error a hook class of its own instead. */
  & > .inline-error {
    display: inline-block;
    animation: fade-out 3s forwards;
    bottom: -1.8rem;
  }
}
